import NewRoute from './NewRoute'

export default NewRoute



// WEBPACK FOOTER //
// ./src/components/Routes/New/index.js